import { exampleBusiness } from '../business';

export interface LeadSubscription {
  id: number;
  userID: number;
  businessID: number;
  businessName: string;
  createdAt?: string; // ISO Date
  updatedAt?: string; // ISO Date
  receiveLeads: boolean;
  receiveStatus: boolean;
}

export const exampleLeadSubscription: LeadSubscription = {
  id: 0,
  userID: 0,
  businessID: exampleBusiness.id,
  businessName: exampleBusiness.businessName,
  receiveLeads: true,
  receiveStatus: true,
};
